import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Counter } from 'components/common/counter';

import { searchKeys } from './../../constants';
import { updateSearchKey } from 'features/userSlice';
import { useGetBookingData } from 'hooks';
import { setMobileSearchOptions } from 'features/multiproperty/MultipropertySlice';

import './RoomsAdultsSearch.css';

const RoomsAdultsSearch = ({
    Lang = {},
    isMobile = false,
    setSearchOptions,
    searchOptions,
}) => {
    const dispatch = useDispatch();

    const calendarAlert = useSelector((state) => state.user?.calendarAlert);
    const disableChildrenSearch = useSelector(
        (state) => state.miniBookingWidget?.data?.disableChildrenSearch
    );
    const userProvidedData = useSelector((state) => state.user);

    const handleCounterChange = (key, value) => {
        if (setSearchOptions) {
            setSearchOptions(key, value);
        } else {
            dispatch(updateSearchKey({ key, value }));
        }
    };

    const { getBookingData } = useGetBookingData();
    const selectedPropertyId = useSelector(
        (state) => state.multiproperty?.selectedPropertyId
    );

    const isMobileSearchOptionsOpen = useSelector(
        (state) => state.multiproperty?.isMobileSearchOptionsOpen
    );

    let initValRooms = userProvidedData[searchKeys.NUMBER_OF_ROOMS];
    let initValAdults = userProvidedData[searchKeys.ADULTS];
    let initValChildren = userProvidedData[searchKeys.CHILDREN];
    if (searchOptions) {
        initValRooms = searchOptions.numberOfRooms;
        initValAdults = searchOptions.adults;
        initValChildren = searchOptions.children;
    }
    return (
        <>
            {isMobile && (
                <div className="ab-popup-title">
                    <span
                        className="ab-popup-closer"
                        onClick={() => {
                            dispatch(
                                setMobileSearchOptions({
                                    isMobileSearchOptionsOpen:
                                        !isMobileSearchOptionsOpen,
                                })
                            );
                        }}
                    >
                        {Lang?.close}
                    </span>
                </div>
            )}

            <div className="ab-popup-content">
                <div className="ab-dropdown-adults-inner">
                    {/* TODO: NEEDS TO COME FROM BACKEND */}
                    <Counter
                        label="Rooms"
                        initialValue={initValRooms}
                        onChange={handleCounterChange}
                        searchKey={searchKeys.NUMBER_OF_ROOMS}
                        lowestValue={1}
                    />
                    <Counter
                        label="Adults"
                        initialValue={initValAdults}
                        onChange={handleCounterChange}
                        searchKey={searchKeys.ADULTS}
                        lowestValue={1}
                    />
                    {!disableChildrenSearch && (
                        <Counter
                            label="Children"
                            initialValue={initValChildren}
                            onChange={handleCounterChange}
                            searchKey={searchKeys.CHILDREN}
                        />
                    )}
                    {isMobile && (
                        <div
                            className="ab-popup-footer ab-incrementor"
                            style={{ paddingBottom: '10px', marginTop: '8px' }}
                        >
                            <button
                                role="button"
                                className="ab-btn ab-search-options-btn"
                                tabIndex="0"
                                aria-disabled={Boolean(calendarAlert)}
                                title=""
                                type="submit"
                                // TODO: REPLACE THIS
                                aria-label={Lang?.search}
                                onClick={() => {
                                    getBookingData({
                                        propertyId: selectedPropertyId,
                                    });
                                    dispatch(
                                        setMobileSearchOptions({
                                            isMobileSearchOptionsOpen:
                                                !isMobileSearchOptionsOpen,
                                        })
                                    );
                                }}
                                disabled={Boolean(calendarAlert)}
                            >
                                <div className="ab-btn-container">
                                    <div className="ab-btn-content">
                                        {Lang?.submit}
                                    </div>
                                </div>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
RoomsAdultsSearch.propTypes = {
    Lang: PropTypes.object,
    isMobile: PropTypes.bool,
    setSearchOptions: PropTypes.func,
    searchOptions: PropTypes.object,
};
export default RoomsAdultsSearch;
